import { useTranslation } from 'react-i18next';
import React, { useContext, useState, useEffect } from "react"
import ListComponent from "@/components/listComponent"
import TopSearch from "@/components/TopSearch"
import { vehicleBrandList,vehicleBrandDisable, vehicleBrandDelete } from "@/service/brandManage"
import { MyContext } from "@/store/myContext"
import { fileLookUrl } from "@/config/app"
import { Image, Modal } from "antd"

//系统配置
const InstrumentLampType = () => {
    const { t } = useTranslation();
    const { dispatch, state, message, detailsPage, Switch } = useContext(MyContext)
    const [instrumentLampTypeList, setInstrumentLampTypeList] = useState([]) //列表
    const [selectInfo, setSelectInfo] = useState({ rowInfo: {}, rowIndex: -1 }) //记录当前行下标
    const [searchValue, setSearchValue] = useState({}) //搜索
    const [pagination, setpagination] = useState({
        //分页配置
        total: 0,
        current: 1,
        pageSize: 10,
    })

    useEffect(() => {
        if (state.activeMenu === "brandManage") {
            loadData()
        }
        return () => setInstrumentLampTypeList([])
    }, [state.activeMenu])

    //列表数据
    const loadData = (current, searchValue = {}) => {
        let data = {
            searchItem: { type: "brand", ...searchValue }, // 只查品牌
            pageNum: current,
            pageSize: 10,
            orders: [{ column: "updateTime", rule: "DESC" }],
        }
        vehicleBrandList(data).then((res) => {
            setSelectInfo({ rowInfo: {}, rowIndex: -1 })
            setpagination({
                current: current,
                total: res.retData.total,
                pageSize: 10,
            })
            setInstrumentLampTypeList(res.retData.list)
        })
    }
    //分页事件
    const onTableChange = async (page) => {
        await setpagination({
            ...pagination,
            current: page.current,
        })
        loadData(page.current)
    }
    //新增 编辑
    const handleDetails = async (mode) => {
        let tabName = {
            insert: t(`dataManage.brandManage.index.品牌新增`),
            edit: t(`dataManage.brandManage.index.品牌编辑`),
        }
        let modeKey = "brandManage/" + mode
        if (mode === "edit") {
            if (!Object.keys(selectInfo.rowInfo).length) {
                message.warning(t(`dataManage.brandManage.index.请选择你要编辑的信息`))
                return
            }
            modeKey += "/" + selectInfo.rowInfo.id
        }
        await dispatch({
            type: "changeTabs",
            name: tabName[mode],
            activeMenu: modeKey,
            content: detailsPage.BrandManageDetails({
                modeKey,
                dispatch,
                mode,
                rowInfo: selectInfo.rowInfo,
            }),
        })
    }
     //删除
     const handleDelete = async () => {
        if (!Object.keys(selectInfo.rowInfo).length) {
            message.warning(t(`dataManage.brandManage.index.请选择你要删除的品牌信息`))
            return
        }
        Modal.confirm({
            content: `${t(`dataManage.brandManage.index.确定要删除品牌`)} - ${selectInfo.rowInfo.name}?`,
            okText: t(`dataManage.brandManage.index.确定`),
            cancelText: t(`dataManage.brandManage.index.取消`),
            centered: true,
            onOk() {
                vehicleBrandDelete(selectInfo.rowInfo.id).then((res) => {
                        message.success(t(`dataManage.brandManage.index.删除成功`))
                        loadData(pagination.current)
                })
            },
        })
    }
    //配置开关
    const sweitchChange = (checked, e, id) => {
        e.stopPropagation()
        vehicleBrandDisable({ id: id, disableFlag: checked ? 0 : 1 }).then((res) => {
            message.success(t(`dataManage.brandManage.index.操作成功`))
        })
        loadData(pagination.current, searchValue)
    }
    //table配置
    const columns = [
        {
            title: t(`dataManage.brandManage.index.名称`),
            align: "center",
            dataIndex: "name",
            with: 100,
        },
        {
            title: t(`dataManage.brandManage.index.图片`),
            align: "center",
            dataIndex: "logo",
            render: (text) => (text ? <Image src={`${fileLookUrl().image}${text}`} width={34} height={34} /> : null),
        },
        {
            title: t(`dataManage.brandManage.index.操作`),
            align: "center",
            width: "12%",
            dataIndex: "disableFlag",
            render: (text, record) => (
                <Switch
                    size="small"
                    defaultChecked={text === 0 ? true : false}
                    checkedChildren= {t(`dataManage.brandManage.index.开启`)}
                    unCheckedChildren= {t(`dataManage.brandManage.index.关闭`)}
                    onChange={(checked, e) => sweitchChange(checked, e, record.id)}
                />
            ),
        },
    ]
    //列表button
    const topButtons = [
        {
            click: () => handleDetails("insert"),
            content: t(`dataManage.brandManage.index.新增`),
        },
        {
            click: () => handleDetails("edit"),
            content: t(`dataManage.brandManage.index.编辑`),
        },
        {
            click: () => handleDelete(),
            content: t(`dataManage.brandManage.index.删除`),
        },
    ]

    //搜索JSON
    const searchList = {
        normalList: [
            {
                type: "input",
                placeholder: t(`dataManage.brandManage.index.品牌名称`),
                valueName: "name",
            },
            {
                type: "Checkbox",
                valueName: "disableFlag",
                placeholder: t(`dataManage.brandManage.index.禁用状态`),
                defaultChecked: searchValue.disableFlag ? true : false,
            },
        ],
    }
    return (
        <>
            {state.activeMenu === "brandManage" && (
                <>
                    <TopSearch
                        title= {t(`dataManage.brandManage.index.品牌管理`)}
                        justify="end"
                        searchListData={searchList}
                        searchValue={searchValue}
                        setSearchValue={(obj) => setSearchValue(obj)}
                        handleSearch={loadData}
                    />
                    <ListComponent
                        title= {t(`dataManage.brandManage.index.品牌管理`)}
                        buttons={topButtons}
                        columns={columns}
                        dataSource={instrumentLampTypeList}
                        pagination={pagination}
                        onTableChange={onTableChange}
                        selectInfo={selectInfo}
                        setSelectInfo={(obj) => setSelectInfo(obj)}
                        scroll={{ x: "100%" }}
                    />
                </>
            )}
        </>
    )
}
export default InstrumentLampType
